module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"summary":"Summary","exports":"Exports","lists":"Monitor"},"fr":{"summary":"Sommaire","exports":"Exports","lists":"À surveiller"}}')
  delete Component.options._Ctor
}
